import { render, staticRenderFns } from "./FeedbackFormModal.vue?vue&type=template&id=48c0ee06&scoped=true&"
import script from "./FeedbackFormModal.vue?vue&type=script&lang=js&"
export * from "./FeedbackFormModal.vue?vue&type=script&lang=js&"
import style0 from "./FeedbackFormModal.vue?vue&type=style&index=0&id=48c0ee06&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48c0ee06",
  null
  
)

export default component.exports